import { useNavigate } from 'react-router';
import { ArrowRight, Sparkles } from 'lucide-react';

/**
 * Marketing-style placeholder home page per CLAUDE.md §10.1.1.
 *
 * Single-screen, Stripe-styled, with a sign-up CTA. Intentionally bare —
 * marketing copy and visuals get a proper pass once the product side ships.
 */
export function HomePage() {
  const navigate = useNavigate();

  return (
    <main className="bg-background text-foreground min-h-screen">
      <header className="border-border border-b">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <span className="text-foreground text-lg font-semibold tracking-tight">Mailchute.ai</span>
          <nav className="flex items-center gap-6 text-sm">
            <button
              type="button"
              onClick={() => {
                void navigate('/signin');
              }}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Sign in
            </button>
            <button
              type="button"
              onClick={() => {
                void navigate('/signup');
              }}
              className="bg-primary text-primary-foreground hover:bg-primary/90 inline-flex items-center gap-1.5 rounded-md px-3.5 py-2 text-sm font-medium transition-colors"
            >
              Get started <ArrowRight className="size-4" aria-hidden />
            </button>
          </nav>
        </div>
      </header>

      <section className="mx-auto max-w-6xl px-6 py-24 sm:py-32">
        <div className="flex flex-col items-start gap-6">
          <span className="border-border bg-muted text-muted-foreground inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium">
            <Sparkles className="size-3" aria-hidden />
            Now in private beta for BigCommerce merchants
          </span>

          <h1 className="text-foreground max-w-3xl text-4xl font-semibold tracking-tight sm:text-5xl">
            Shipping software you can talk to — and that your AI tools can talk to too.
          </h1>

          <p className="text-muted-foreground max-w-2xl text-lg">
            Mailchute.ai. Down the chute and on its way. Per-label pricing, no tiers, no
            drag-and-drop rule builders, no fluff. Royal Mail at launch.
          </p>

          <div className="mt-2 flex flex-wrap items-center gap-3">
            <button
              type="button"
              onClick={() => {
                void navigate('/signup');
              }}
              className="bg-primary text-primary-foreground hover:bg-primary/90 inline-flex items-center gap-1.5 rounded-md px-5 py-2.5 text-sm font-medium transition-colors"
            >
              Get started <ArrowRight className="size-4" aria-hidden />
            </button>
            <a
              href="mailto:hello@mailchute.ai"
              className="text-muted-foreground hover:text-foreground inline-flex items-center text-sm transition-colors"
            >
              Or contact sales
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
